import React from 'react';
import { adminApi } from '../admin/api';
import { STAFF_APPS } from '@/lib/staffApps';
import AppHandoff from './AppHandoff';

// The Learn tab's landing: mint a 2-minute single-use SSO token and hand the browser to
// the federated Learn app (Neuro93Saturn), whose /api/auth/portal redeems it against the
// portal backend and mints its own session. In prod Learn lives same-origin at /learn
// (Cloudflare Worker route); in dev point REACT_APP_LEARN_URL at the local Next server.
const LEARN_URL = process.env.REACT_APP_LEARN_URL || '/learn';
const LEARN = STAFF_APPS.find((a) => a.key === 'learn');

const mint = () => adminApi.post('/auth/learn-token').then((r) => r.data.token);
const target = (token) => `${LEARN_URL}/api/auth/portal?token=${encodeURIComponent(token)}`;

export default function LearnLauncher() {
  return <AppHandoff app={LEARN} mint={mint} target={target} />;
}
